import { Fragment, ReactElement, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getBaseUrl } from '../get-base-url';
import ResearchCohabitationNotificationShared from '../../research-notifications/research-cohabitation';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchCohabitationNotificationCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchCohabitationNotificationCivilStatusShared = ({
  scope,
  items,
}: ResearchCohabitationNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  return (
    <Fragment>
      <ResearchCohabitationNotificationShared goBackUrl={goBackUrl} items={items} />
    </Fragment>
  );
};

ResearchCohabitationNotificationCivilStatusShared.displayName =
  'Research Cohabitation Notifications Page component';

export default ResearchCohabitationNotificationCivilStatusShared;
